import { env } from '../env/env';
const GATEWAY_URL = env.getString('GATEWAY_URL') || 'http://localhost:9089';
export const LEGACY_C2FO_API_URL = `${GATEWAY_URL}/api/c2fo`;
export const LEGACY_C2FO_API_USERCAST_URL = `${GATEWAY_URL}/usercast/api/c2fo`;
export const LEGACY_CALC_API_URL = `${GATEWAY_URL}/api/calc`;
export const LEGACY_C2FO_API_FIND_URL = `${GATEWAY_URL}/find/api/c2fo`;
//# sourceMappingURL=legacyC2foApiConfig.js.map